import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  inject,
  input,
  OnDestroy,
  signal,
} from '@angular/core';
import { HlmCheckboxImports } from '@spartan-ng/helm/checkbox';
import { hlm } from '@spartan-ng/helm/utils';
import type { ClassValue } from 'clsx';

@Component({
  selector: 'hlm-dropdown-menu-checkbox-indicator',
  imports: [HlmCheckboxImports],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': '_computedClass()',
  },
  template: ` <hlm-checkbox [checked]="isChecked()" [indeterminate]="isIndeterminate()" /> `,
})
export class HlmDropdownMenuCheckboxIndicator implements AfterViewInit, OnDestroy {
  private readonly elRef = inject(ElementRef);
  private _observer?: MutationObserver;

  public readonly userClass = input<ClassValue>('', { alias: 'class' });
  protected readonly _computedClass = computed(() =>
    hlm('pointer-events-none absolute left-2 flex size-3.5 items-center justify-center', this.userClass()),
  );

  public readonly isChecked = signal(false);
  public readonly isIndeterminate = signal(false);

  ngAfterViewInit(): void {
    const boutonParent: HTMLElement | null = this.elRef.nativeElement.closest('button');
    if (!boutonParent) {
      return;
    }

    // Synchronise l'état affiché à chaque changement des attributs data-* du bouton parent,
    // sinon l'indicateur resterait figé sur sa valeur initiale tant que le menu reste ouvert.
    const synchroniser = () => {
      this.isChecked.set(boutonParent.getAttribute('data-checked') !== null);
      this.isIndeterminate.set(boutonParent.getAttribute('data-indeterminate') !== null);
    };
    synchroniser();

    this._observer = new MutationObserver(synchroniser);
    this._observer.observe(boutonParent, {
      attributes: true,
      attributeFilter: ['data-checked', 'data-indeterminate'],
    });
  }

  ngOnDestroy(): void {
    this._observer?.disconnect();
  }
}
